<script setup lang="ts">
import SuccessFormIcon from 'assets/icons/success-form.svg'
import Button from '~/components/common/Button.vue'

defineEmits<{ close: [] }>()

withDefaults(
  defineProps<{
    message?: string
    withCloseButton?: boolean
  }>(),
  {
    withCloseButton: true,
    message:
      'Thank you for contacting us, our team will be in touch with you shortly.',
  },
)
</script>

<template>
  <div
    class="flex h-full max-w-96 flex-col items-center justify-center gap-y-10"
  >
    <div class="flex flex-col items-center gap-y-10">
      <SuccessFormIcon />
      <span class="text-center font-semibold">{{ message }}</span>
    </div>
    <div
      v-if="withCloseButton"
      class="flex w-full flex-col items-center gap-y-2"
    >
      <Button class="!w-full" @click="$emit('close')">Close</Button>
    </div>
  </div>
</template>
